export default __webpack_public_path__ + "static/media/ThenaLogo.6501d9d1.svg";